import { useEffect } from 'react';
import { Flex, Image, Typography, App } from 'antd';
import CopyIcon from "../../assets/icons/copy.svg";
import Whatsapp from "../../assets/icons/whatsapp.svg";
import Mail from "../../assets/icons/mail.svg";
import { CheckOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getEscrowDetailsByOrgId, sendDepositDetails } from '../../redux/slices/ProfileSlice';
import { GLOBAL_CONSTANTS, SUCCESS_MSGS, TITLE_TXT } from '../../constants/constants';
import { capitalizeEntireWord } from '../../helpers/helpers';
import EscrowDetail from '../Details/EscrowDetail';
import "./AccountDetails.scss";
import ShareDetail from '../Details/ShareDetail';

const { Title, Text } = Typography;

const AccountDetails = ({ title, details }) => {
    const { message } = App.useApp();
    const { user } = useSelector((state) => state.auth);
    const { escrowDetailsData } = useSelector((state) => state.profile);
    const dispatch = useDispatch();

    // ✅ use passed prop if available, else fallback to Redux state
    const dataToShow = details || escrowDetailsData;

    useEffect(() => {
        if (!details) {
            dispatch(getEscrowDetailsByOrgId(user?.orgId));
        }
    }, [dispatch, user?.orgId, details]);

    const copyable = {
        icon: [
            <Image preview={false} src={CopyIcon} alt='Copy Icon' key="copy" />,
            <CheckOutlined key="copied" />
        ],
    };

    const handleSendDeposit = async () => {
        const payload = {
            email: user?.email,
            name: user?.userName,
            beneficiaryName: dataToShow?.accHolderName,
            escrowBankName: dataToShow?.bankName,
            escrowBranchName: dataToShow?.branchName,
            escrowAccountNumber: dataToShow?.accNum,
            escrowIfscCode: dataToShow?.ifscCode,
        };

        const res = await dispatch(sendDepositDetails(payload));
        if (res.payload.statusCode === 200) {
            message.success(SUCCESS_MSGS.ECW_DET_SUC_MSG);
        }
    };

    return (
        <div className='account-details-container'>
            <Flex gap="small" align="center" style={{ marginBottom: 30 }}>
                <Flex vertical>
                    <Title level={5}>{title}</Title>
                </Flex>
            </Flex>

            <div className='details-container'>
                <EscrowDetail
                    vertical
                    gap="small"
                    title={TITLE_TXT.ECW_BEN_ACC_NAME}
                    descLevel={5}
                    copyable={copyable}
                    desc={capitalizeEntireWord(dataToShow?.accHolderName)}
                />
                <EscrowDetail
                    vertical
                    gap="small"
                    title={TITLE_TXT.ECW_BANK_NAME}
                    descLevel={5}
                    copyable={copyable}
                    desc={capitalizeEntireWord(dataToShow?.bankName)}
                />
                <EscrowDetail
                    vertical
                    gap="small"
                    title={TITLE_TXT.ECW_BRANCH_NAME}
                    descLevel={5}
                    copyable={copyable}
                    desc={capitalizeEntireWord(dataToShow?.branchName)}
                />
                <EscrowDetail
                    vertical
                    gap="small"
                    title={TITLE_TXT.ECW_BANK_ACC_NUM}
                    descLevel={5}
                    copyable={copyable}
                    desc={capitalizeEntireWord(dataToShow?.accNum)}
                />
                <EscrowDetail
                    vertical
                    gap="small"
                    title={TITLE_TXT.ECW_IFSC_CODE}
                    descLevel={5}
                    copyable={copyable}
                    desc={capitalizeEntireWord(dataToShow?.ifscCode)}
                />
            </div>

            <Text strong>{GLOBAL_CONSTANTS.SHARE_TXT}</Text>
            <div className='share-container'>
                <ShareDetail
                    popTitle={TITLE_TXT.DEPO_DET_TO_WHATSAPP_CONFIRM_TXT}
                    onConfirm={() => { }}
                    icon={Whatsapp}
                    shareDesc={GLOBAL_CONSTANTS.WHATSAPP}
                />
                <ShareDetail
                    popTitle={TITLE_TXT.DEPO_DET_TO_EMAIL_CONFIRM_TXT}
                    onConfirm={handleSendDeposit}
                    icon={Mail}
                    shareDesc={GLOBAL_CONSTANTS.EMAIL}
                />
            </div>
        </div>
    );
};

export default AccountDetails;
